<bn-brightnav-layout>
  <bn-client-list column1 [collapsed]="collapsed()" />
  <lib-chat
    column2
    class="flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden"
  ></lib-chat>
</bn-brightnav-layout>
